export const playbackRates = [0.5, 0.75, 1, 1.25, 1.5, 2];
export default playbackRates;
